'use client'

import ShopMarketplaceCarousel from './ShopMarketplaceCarousel'

export interface ShopMarketplaceCarouselBatchItem {
  id: string
  title: string
  carouselName: string
  screenName?: string
  viewMoreUrl?: string
  endpoint: string | string[]
  carousel_position?: number
}

/**
 * Maps a batch of carousel configs to `ShopMarketplaceCarousel`s on the
 * client side of the server/client boundary.
 *
 * `ShopMarketplaceCarousel` is a Client Component, so building the array of
 * them in the server component above (`PrefetchedShopMarketplaceCarousel`)
 * means each one crosses the RSC boundary as its own flight row — the same
 * shape that caused a real hydration bug in the Seller Spotlight carousel
 * (see its own fix). Taking the plain `carousels` config array across the
 * boundary instead, and mapping it here, keeps that crossing to one.
 */
export default function ShopMarketplaceCarouselBatch({
  carousels,
}: {
  carousels: ShopMarketplaceCarouselBatchItem[]
}) {
  return (
    <>
      {carousels.map((carousel) => (
        <ShopMarketplaceCarousel
          key={carousel.id}
          title={carousel.title}
          carousel_name={carousel.carouselName}
          screenName={carousel.screenName}
          viewMoreUrl={carousel.viewMoreUrl}
          endpoint={carousel.endpoint}
          carousel_position={carousel.carousel_position}
        />
      ))}
    </>
  )
}
